import { HttpClient } from '@angular/common/http';
import {
  TRANSLOCO_LOADER,
  Translation,
  TranslocoLoader,
  TRANSLOCO_CONFIG,
  translocoConfig,
  TranslocoModule
} from '@ngneat/transloco';
import { Injectable, NgModule } from '@angular/core';
import { environment } from '../environments/environment';

@Injectable({ providedIn: 'root' })
export class TranslocoHttpLoader implements TranslocoLoader {
  constructor(private http: HttpClient) { }

  getTranslation(lang: string) {
    return this.http.get<Translation>(`/assets/i18n/${lang}.json`);
  }

}
const selectedLanguage = localStorage.getItem('selectedLanguage') || 'en';
@NgModule({
  exports: [TranslocoModule],
  providers: [
    // {
    //   provide: TRANSLOCO_CONFIG,
    //   useValue: translocoConfig({
    //     availableLangs: ['en', 'fr'],
    //     defaultLang: selectedLanguage,
    //     reRenderOnLangChange: true,
    //     prodMode: environment.production,
    //     fallbackLang: 'en',
    //     flatten: {
    //       aot: true
    //     },
    //     missingHandler: {
    //       logMissingKey: false,
    //       useFallbackTranslation: true
    //     }
    //   }),
    // },
    { provide: TRANSLOCO_LOADER, useClass: TranslocoHttpLoader }
  ]
})
export class TranslocoRootModule { }
